module.exports = ":root {\n  display: inline; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/copy-clipboard/copy-clipboard.component.scss
// module id = ./src/app/shared/copy-clipboard/copy-clipboard.component.scss
// module chunks = main